import { render, staticRenderFns } from "./Slideshow.vue?vue&type=template&id=2d12ab40&scoped=true"
import script from "./Slideshow.vue?vue&type=script&lang=js"
export * from "./Slideshow.vue?vue&type=script&lang=js"
import style0 from "./Slideshow.vue?vue&type=style&index=0&id=2d12ab40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d12ab40",
  null
  
)

export default component.exports